import {observer} from "mobx-react";
import {useStore} from "../../stores/Store";
import {Box, Chip} from "@mui/material";
import React from "react";
import {BassType} from "../../models/BassType";
import {RightHandSystem} from "../../models/RightHandSystem";

export default observer(function AccordionFilterSummary(){
    const { AccordionStore, LanguageStore } = useStore();
    const { filteredBrand, setFilteredBrand, filteredBassType, setFilteredBassType,
        filteredRightSystem, setFilteredRightSystem, findLightiestAndHeaviestWeight,
        findLowestAndHighestHeight, filteredHeight, filteredWeight, setFilteredWeight,
        setFilteredHeight, filteredWidth, findLowestAndHighestWidth, setFilteredWidth, filteredNotesRightBtn,
        setFilteredNotesRightBtn, filteredRightBtnRow, setFilteredRightBtnRow, filteredChorusRight, setFilteredChorusRight,
        filteredCassottoRight, setFilteredCassottoRight, setFilteredRegisterRight, filteredRegisterRight,
        setFilteredChinSwitches, filteredChinSwitches, filteredRowsBtnLeft, setFilteredRowsBtnLeft,
        filteredStandardBass, setFilteredStandardBass, setFilteredStandardBassChorus, filteredStandardBassChorus,
        filteredChorusFb, setFilteredChorusFb, filteredRegisterFb, setFilteredRegisterSb, filteredRegisterSb,
        setFilteredNotesFb, setFilteredRegisterFb, filteredNotesFb, filteredNotesRightPiano, setFilteredNotesRightPiano,
        filteredDurallReeds, filteredFamReeds, filteredTurboReeds, filteredTamReeds, setFilteredTurboReeds, setFilteredTamReeds,
        setFilteredFamReeds, setFilteredDurallReeds
    } = AccordionStore;
    const { currentLanguageMessages } = LanguageStore;

    const allFilters = [
        {bool: filteredBrand !== undefined, value: filteredBrand, label: `${currentLanguageMessages.AccordionsPage.Filter.brandTitle}: ${filteredBrand}`, setValue: setFilteredBrand, param: undefined},
        {
            bool: filteredBassType !== undefined,
            value: filteredBassType,
            setValue: setFilteredBassType,
            label: `${currentLanguageMessages.AccordionsPage.Filter.BassType.title}: ${(filteredBassType === BassType.Convertor) ? currentLanguageMessages.AccordionsPage.Filter.BassType.convertor : currentLanguageMessages.AccordionsPage.Filter.BassType.standard }`,
            param: undefined
        },
        {
            bool: filteredRightSystem !== undefined,
            value: filteredRightSystem,
            setValue: setFilteredRightSystem,
            label: `${currentLanguageMessages.AccordionsPage.Filter.RightHandSystem.title}: ${(filteredRightSystem === RightHandSystem.Button) ? currentLanguageMessages.AccordionsPage.Filter.RightHandSystem.buttons : currentLanguageMessages.AccordionsPage.Filter.RightHandSystem.keys }`,
            param: undefined,
        },
        {
          bool: filteredNotesRightPiano !== undefined,
          value: filteredNotesRightPiano,
          setValue: setFilteredNotesRightPiano,
          label: `${currentLanguageMessages.AccordionsPage.Filter.RightNotesPiano.title}: ${currentLanguageMessages.AccordionsPage.Filter.RightHandSystem.keys}`,
          param: undefined,
        },
        {
            bool: filteredRightBtnRow !== undefined,
            value: filteredRightBtnRow,
            setValue: setFilteredRightBtnRow,
            label: `${currentLanguageMessages.AccordionsPage.Filter.rightHandCategoryTitle} ${currentLanguageMessages.AccordionsPage.Filter.Rows.title}: ${filteredRightBtnRow}`,
            param: undefined,
        },
        {
            bool: filteredNotesRightBtn !== undefined,
            value: filteredNotesRightBtn,
            setValue: setFilteredNotesRightBtn,
            label: `${currentLanguageMessages.AccordionsPage.Filter.RightHandButtons.title}: ${filteredNotesRightBtn}`,
            param: undefined,
        },
        {
            bool: filteredChorusRight !== undefined,
            value: filteredChorusRight,
            setValue: setFilteredChorusRight,
            label: `${currentLanguageMessages.AccordionsPage.Filter.rightHandCategoryTitle} ${currentLanguageMessages.AccordionsPage.Filter.ChorusRight.title}: ${filteredChorusRight}`,
            param: undefined,
        },
        {
            bool: filteredCassottoRight !== undefined,
            value: filteredCassottoRight,
            setValue: setFilteredCassottoRight,
            label: `${currentLanguageMessages.AccordionsPage.Filter.CassottoRight.title}: ${filteredCassottoRight}`,
            param: undefined,
        },
        {
            bool: filteredRegisterRight !== undefined,
            value: filteredRegisterRight,
            setValue: setFilteredRegisterRight,
            label: `${currentLanguageMessages.AccordionsPage.Filter.rightHandCategoryTitle} ${currentLanguageMessages.AccordionsPage.Filter.RegisterRight.title}: ${filteredRegisterRight}`,
            param: undefined,
        },
        {
            bool: filteredChinSwitches !== undefined,
            value: filteredChinSwitches,
            setValue: setFilteredChinSwitches,
            label: `${currentLanguageMessages.AccordionsPage.Filter.ChinSwitches.title}: ${filteredChinSwitches}`,
            param: undefined,
        },
        {
            bool: filteredRowsBtnLeft !== undefined,
            value: filteredRowsBtnLeft,
            setValue: setFilteredRowsBtnLeft,
            label: `${currentLanguageMessages.AccordionsPage.Filter.leftHandCategoryTitle} ${currentLanguageMessages.AccordionsPage.Filter.Rows.title}: ${filteredRowsBtnLeft}`,
            param: undefined,
        },
        {
            bool: filteredStandardBass !== undefined,
            value: filteredStandardBass,
            setValue: setFilteredStandardBass,
            label: `${currentLanguageMessages.AccordionsPage.Filter.standardBassCategoryTitle}: ${filteredStandardBass}`,
            param: undefined,
        },
        {
            bool: filteredStandardBassChorus !== undefined,
            value: filteredStandardBassChorus,
            setValue: setFilteredStandardBassChorus,
            label: `${currentLanguageMessages.AccordionsPage.Filter.standardBassCategoryTitle} ${currentLanguageMessages.AccordionsPage.Filter.StandardBassChorus.title}: ${filteredStandardBassChorus}`,
            param: undefined,
        },
        {
            bool: filteredRegisterSb !== undefined,
            value: filteredRegisterSb,
            setValue: setFilteredRegisterSb,
            label: `${currentLanguageMessages.AccordionsPage.Filter.standardBassCategoryTitle} ${currentLanguageMessages.AccordionsPage.Filter.RegisterSb.title}: ${filteredRegisterSb}`,
            param: undefined,
        },
        {
            bool: filteredNotesFb !== undefined,
            value: filteredNotesFb,
            setValue: setFilteredNotesFb,
            label: `${currentLanguageMessages.AccordionsPage.Filter.freeBassCategoryTitle} ${currentLanguageMessages.AccordionsPage.Filter.FreeBassNotes.title}: ${filteredNotesFb}`,
            param: undefined,
        },
        {
            bool: filteredRegisterFb !== undefined,
            value: filteredRegisterFb,
            setValue: setFilteredRegisterFb,
            label: `${currentLanguageMessages.AccordionsPage.Filter.freeBassCategoryTitle} ${currentLanguageMessages.AccordionsPage.Filter.RegisterSb.title}: ${filteredRegisterFb}`,
            param: undefined,
        },
        {
            bool: filteredChorusFb !== undefined,
            value: filteredChorusFb,
            setValue: setFilteredChorusFb,
            label: `${currentLanguageMessages.AccordionsPage.Filter.freeBassCategoryTitle} ${currentLanguageMessages.AccordionsPage.Filter.ChorusFb.title}: ${filteredChorusFb}`,
            param: undefined,
        },
        {
            bool: filteredTamReeds,
            value: filteredTamReeds,
            setValue: setFilteredTamReeds,
            label: `${currentLanguageMessages.AccordionsPage.Filter.ReedsFilter.title}: ${currentLanguageMessages.AccordionsPage.Filter.ReedsFilter.tam}`,
            param: false,
        },
        {
            bool: filteredFamReeds,
            value: filteredFamReeds,
            setValue: setFilteredFamReeds,
            label: `${currentLanguageMessages.AccordionsPage.Filter.ReedsFilter.title}: ${currentLanguageMessages.AccordionsPage.Filter.ReedsFilter.fam}`,
            param: false,
        },
        {
            bool: filteredTurboReeds,
            value: filteredTurboReeds,
            setValue: setFilteredTurboReeds,
            label: `${currentLanguageMessages.AccordionsPage.Filter.ReedsFilter.title}: ${currentLanguageMessages.AccordionsPage.Filter.ReedsFilter.turbo}`,
            param: false,
        },
        {
            bool: filteredDurallReeds,
            value: filteredDurallReeds,
            setValue: setFilteredDurallReeds,
            label: `${currentLanguageMessages.AccordionsPage.Filter.ReedsFilter.title}: ${currentLanguageMessages.AccordionsPage.Filter.ReedsFilter.durall}`,
            param: false,
        },
        {
            bool: (filteredWidth[0] !== findLowestAndHighestWidth()[0] || filteredWidth[1] !== findLowestAndHighestWidth()[1]),
            value: filteredWidth,
            setValue: setFilteredWidth,
            label: `${currentLanguageMessages.AccordionsPage.Filter.Width.title}: ${filteredWidth[0]}cm - ${filteredWidth[1]}cm`,
            param: findLowestAndHighestWidth()
        },
        {
            bool: (filteredHeight[0] !== findLowestAndHighestHeight()[0] || filteredHeight[1] !== findLowestAndHighestHeight()[1]),
            value: filteredHeight,
            setValue: setFilteredHeight,
            label: `${currentLanguageMessages.AccordionsPage.Filter.Height.title}: ${filteredHeight[0]}cm - ${filteredHeight[1]}cm`,
            param: findLowestAndHighestHeight()
        },
        {
            bool: (filteredWeight[0] !== findLightiestAndHeaviestWeight()[0] || filteredWeight[1] !== findLightiestAndHeaviestWeight()[1]),
            value: filteredWeight,
            setValue: setFilteredWeight,
            label: `${currentLanguageMessages.AccordionsPage.Filter.Weight.title}: ${filteredWeight[0]}kg - ${filteredWeight[1]}kg`,
            param: findLightiestAndHeaviestWeight()
        }
    ]

    return (
        <Box sx={{
            mt: 0.75,
            height: 32,
            display: 'flex',
            justifyContent: 'center',
            overflowX: 'scroll',
            // Hide scrollbar for Webkit and Firefox
            '&::-webkit-scrollbar': {
                display: 'none'
            },
            scrollbarWidth: 'none', // for Firefox
            msOverflowStyle: 'none'  // for Internet Explorer 10+
        }}>
            {
                allFilters.map((filter, index) => (filter.bool) ?
                    <Chip
                        key={index}
                        sx={{ml: 2}}
                        label={filter.label}
                        //@ts-ignore
                        onDelete={() => filter.setValue(filter.param)}
                    ></Chip> :
                    null
                )
            }
        </Box>
    )
})